import React from 'react'
import Layout from './layout'
import signupData from '../components/content/signup/signup.en-XC.yaml'
import Sign from '../templates/signupForm'
import Image from '../templates/Image'

export default function Signup() {
  // console
  return (
    <Layout title={signupData && signupData.title}>
      <div className="signup-wrapper">
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 signup-logo">
          <Image
            className="signup-img"
            border="0"
            src={signupData.content.img.url1}
            alt="Hero Icon"
          />
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12 signup-content-desc">
              <h1>{signupData.content.title}</h1>
              <p>{signupData.content.description}</p>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}
              >
                <div
                  style={{
                    background: '#fddbd3',
                    width: '90%',
                    borderRadius: '8px',
                  }}
                >
                  <blockquote
                    style={{ margin: '10px 0', padding: '10px 20px' }}
                  >
                    <strong>Important:</strong> Our community signup is getting
                    some needed updates and is not available at the moment.
                  </blockquote>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              {/* {>"layouts/signupForm/form.{locale|s}"/} */}
              <Sign />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}
